import { UserEntity } from 'app/interfaces/entity';
import { ChatUserRoles } from 'modules/chat/enums';
import { getUserAvatarUrl } from 'shared/utils/user-avatar';
import Talk from 'talkjs';

export const createChatUser = (
  user?: UserEntity,
  role: ChatUserRoles = ChatUserRoles.Default
): Talk.User | null => {
  if (!user) {
    return null;
  }

  return new Talk.User({
    id: user.id,
    name: user.userName,
    email: user.email,
    photoUrl: getUserAvatarUrl(user, 48),
    role,
  });
};
